<template>
  <div class="app" v-title data-title="富林印迹-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="3" />
    <div class="yj-banner rel">
      <img src="@/assets/images/zx-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <!-- <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/zixun" class="f16 fw">资讯动态</router-link> -->
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">公告信息</div>
        <div class="f17 ls3">Announcement Information</div>
      </div>
    </div>
    <div class="wz-gonglue mt-40 pb100 w1200 auto">
      <div class="df justify_between">
        <div class="wz-gonglue-item w1000">
          <div class="wz-gonglue-box" v-for="item in list" :key="item.Id">
            <router-link :to="`/pages/zixun/zixun-announcement-view?id=${item.Id}`" class="df align_center wz-gonglue-link">
              <div class="wz-gonglue-text f1">
                <div class="f24 line_clamp1 b" v-if="item.Name">{{ item.Name }}</div>
                <div class="f16 line_clamp3 mt15" v-if="item.Intro">{{ item.Intro | clearHtml(180) }}</div>
                <div class="df align_center justify_between mt15 op90">
                  <div class="f14" v-if="item.CreateTime">{{ item.CreateTime }}</div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="pages df align_center justify_center pt50 pb50">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="filter.total"
              :current-page="filter.Page"
              :page-size="filter.PageSize"
              @current-change="handleCurrentPage">
            </el-pagination>
          </div>
        </div>
        <div class="wz-gonglue-cate">
          <div class=" bgwh box-border pd20">
            <div class="f20 b tc">时间筛选</div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(0)" :class="timeSelect == 0 ? 'foy' : ''">
              <div>&lt;&lt;&nbsp;</div>
              <div>全部</div>
              <div>&nbsp;&gt;&gt;</div>
            </div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(1)" :class="timeSelect == 1 ? 'foy' : ''">
              <div>近一月</div>
            </div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(2)" :class="timeSelect == 2 ? 'foy' : ''">
              <div>{{new Date().getFullYear()}}年</div>
            </div>
            <div class="df align_center justify_center f16 wz-gonglue-cate-box" style="cursor:pointer" @click="handleRange(3)" :class="timeSelect == 3 ? 'foy' : ''">
              <div>{{new Date().getFullYear() - 1}}年</div>
            </div>
          </div>
        </div>
      </div>



    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import strategyService from '@/services/client/cont/strategy'
import utils,{dateFormaOptions, dateFormaOptionsSimple} from '@/libs/utils'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      filter: {
        Page: 1,
        PageSize: 10,
        beginTime: null,
        endTime: null,
        Kind: "公告信息",
        total: 0,
      },
      list: null,
      timeSelect: 0,

    }
  },
  components: { Header, Bottom,},
  mounted(){
    this.loadData();
  },
  methods:{
    loadData() {
      this.list = null;
      strategyService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data) {
          const data = res.Data;

          this.filter.total = data.Count;
          this.list = data.List;
        }
      })
    },
    handleCurrentPage(page) {
      this.filter.Page = page;

      this.loadData();
    },
    handleRange(idx){
      const date = new Date();
      this.filter.Page = 1;
      this.timeSelect = idx;
      if(idx == 0) {
        this.filter.beginTime = null;
        this.filter.endTime = null;
      }

      if(idx == 1) {
        this.filter.beginTime = utils.dateFormat(new Date(date.getFullYear(), date.getMonth() - 1, date.getDate() + 1), 'yyyy-MM-dd 00:00:00');
        this.filter.endTime = utils.dateFormat(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1), 'yyyy-MM-dd 23:59:59');

        console.log(date);
        console.log(date.getFullYear(), date.getMonth() + 1 - 1, date.getDate());
      }

      if(idx == 2) {
        this.filter.beginTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 00:00:00', {simple:dateFormaOptionsSimple.yearStart});
        this.filter.endTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 23:59:59',{simple:dateFormaOptionsSimple.yeasEnd});
      }

      if(idx == 3) {
        this.filter.beginTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 00:00:00', {simple:dateFormaOptionsSimple.yearStart, addYear: -1});
        this.filter.endTime = utils.dateFormat(new Date(), 'yyyy-MM-dd 23:59:59',{simple:dateFormaOptionsSimple.yeasEnd, addYear: -1});
      }

      this.loadData();
    },
  },

}
</script>



// WEBPACK FOOTER //
// src/views/zixun/zixun-announcement.vue